import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.attemptScroll(0)
    this.preventFocusScroll()
  }

  attemptScroll(attempt) {
    const trigger = document.getElementById("scroll-past-trigger")
    if (!trigger) return

    const targetId = trigger.dataset.scrollTarget
    const target = document.getElementById(targetId)
    if (!target) {
      if (attempt < 5) {
        setTimeout(() => this.attemptScroll(attempt + 1), 200)
      }
      return
    }

    const navbar = document.querySelector(".app-navbar")
    const navbarHeight = navbar ? navbar.offsetHeight : 60
    const targetTop = target.getBoundingClientRect().top + window.scrollY - navbarHeight - 4

    try {
      window.scrollTo({ top: Math.max(0, targetTop), behavior: "instant" })
    } catch(e) {
      window.scrollTo(0, Math.max(0, targetTop))
    }
  }

  // Prevent iOS from scrolling the page when the search input gets focus
  preventFocusScroll() {
    const input = this.element.querySelector(".universal-search-input")
    if (!input) return

    input.addEventListener("focus", () => {
      const scrollY = window.scrollY
      // After iOS adjusts scroll, snap it back
      requestAnimationFrame(() => {
        if (Math.abs(window.scrollY - scrollY) > 5) {
          window.scrollTo({ top: scrollY, behavior: "instant" })
        }
      })
    })
  }
}
